var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 26,
    viewBox: "0 0 16 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8721 14.1553L13.2375 14.8368L13.2451 14.8449L4.19754 24.5612C3.77789 25.0057 3.1936 25.1158 2.69528 24.8928C2.17355 24.6593 1.78882 24.084 1.78882 23.4006L1.78882 23.4002L1.78125 2.60056C1.78125 2.6005 1.78125 2.60044 1.78125 2.60038C1.78125 2.60032 1.78125 2.60026 1.78125 2.60019C1.78138 1.91054 2.16455 1.34244 2.68771 1.10834C3.19194 0.882721 3.77335 0.99247 4.18789 1.43766L13.8721 11.8377C14.4603 12.4693 14.4603 13.5237 13.8721 14.1553Z",
    fill: "#F1FAF5",
    fillOpacity: 0.4,
    stroke: "#F1FAF5",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.cbd11f24a3884a746fe07a1477a2ffb4.svg";
export { ForwardRef as ReactComponent };